import { SxProps, Theme } from '@mui/material/styles';
import { groupBaseSx } from '../Group.styles';

export const radioGroupSx: SxProps<Theme> = {
  ...groupBaseSx,
};
